<template>
  <v-container fluid>
    <v-card flat class="administrator">
      <v-card-title>
        <v-row>
          <v-col>
            <p class="ma-4">{{ totalRecords }} Active Students</p>
          </v-col>
          <v-spacer />
          <v-btn @click="AddNewAccount" color="primary" class="ma-4"
            >Send Activation Link</v-btn
          >
          <ActivationModal
            :accountDialogBox="accountActivationModal"
            @setAccountActivationModal="setAccountActivationModal"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="search"
          class="mx-4"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="students"
          item-key="id"
          :sort-by="['registration_number']"
          :sort-desc="[false]"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
        >
          <!--BEGIN result ID-->
          <template v-slot:[`item.id`]="{ index }">
            <span class="table-exam">{{ index + 1 }}</span>
          </template>
          <!--END result ID-->
          <!--BEGIN unit code-->
          <template v-slot:[`item.unitCode`]="{ item }">
            <span class="table-exam"> {{ item["unitCode"] }}</span>
          </template>
          <!--END unit code-->
          <!--BEGIN year-->
          <template v-slot:[`item.year`]="{ item }">
            <span class="table-exam"> {{ item["year"] }}</span>
          </template>
          <!--END year-->
          <!--BEGIN programme-->
          <template v-slot:[`item.programme`]="{ item }">
            <span class="table-exam"> {{ item["programme"] }}</span>
          </template>
          <!--END programme-->
          <!--BEGIN unit name-->
          <template v-slot:[`item.description`]="{ item }">
            <span class="table-exam">
              <span class="">[{{ item["unitCode"] }}] </span>
              {{ item["description"] }}
            </span>
          </template>
          <!--END unit name-->
          <!--BEGIN sittings-->
          <template v-slot:[`item.sitting`]="{ item }">
            <span class="table-exam"> {{ item["sitting"] }}</span>
          </template>
          <!--END sittings-->
          <!--BEGIN result-->
          <template v-slot:[`item.result`]="{ item }">
            <span class="table-exam"> {{ item["result"] }}</span>
          </template>
          <!--END result-->
          <!--BEGIN grade-->
          <template v-slot:[`item.grade`]="{ item }">
            <span class="table-exam"> {{ item["grade"] }}</span>
          </template>
          <!--END grade-->
          <!--BEGIN status-->
          <template v-slot:[`item.status`]="{ item }">
            <span class="table-exam text-lowercase"
              ><v-icon size="12" color="red">mdi-radiobox-marked</v-icon>
              {{ item["status"] }}</span
            >
          </template>
          <!--END status-->
          <!--BEGIN board actions-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :to="{
                    name: 'StudentCard',
                    params: { reg: item.id },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary" size="">mdi-eye</v-icon>View
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item @click="sendMessage(item)">
                  <span class="table-exam"
                    ><v-icon color="blue" class="mx-1">send</v-icon>Send
                    Message</span
                  >
                </v-list-item>
                <v-divider />
                <v-list-item @click="deleteUser(item)">
                  <span class="table-exam">
                    <v-icon color="error" size=""> delete </v-icon>
                    Delete
                  </span>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END board actions-->
        </v-data-table>
        <div class="">
          <!-- <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            class="my-4"
            :total-visible="10"
            @input="handlePageChange($event)"
          ></v-pagination> -->
        </div>
      </v-card-text>
    </v-card>
    <MessageStudentDialog
      :user="selectedUser"
      :messageDialog="messageDialog"
      @setMessageDialog="setMessageDialog"
    />
  </v-container>
</template>

<script>
import ActivationModal from "./ActivationModal";
import MessageStudentDialog from "./MessageStudentDialog";
export default {
  name: "StudentListComponent",
  components: { ActivationModal, MessageStudentDialog },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/students", { params: { page: 1 } });
    });
  },
  data: () => ({
    search: "",
    page: 1,
    itemsPerPage: 30,
    accountActivationModal: false,
    messageDialog: false,
    selectedUser: {},
    pagination: {
      page: Number,
      itemsPerPage: Number,
      pageStart: Number,
      pageStop: Number,
      pageCount: Number,
      itemsLength: Number,
    },
    headers: [
      {
        text: "S/N",
        align: "left",
        sortable: false,
        value: "id",
      },
      {
        text: "Registration Number",
        align: "left",
        sortable: false,
        value: "registration_number",
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Email",
        align: "left",
        sortable: false,
        value: "email",
      },
      // {
      //   text: "Phone Number",
      //   align: "left",
      //   sortable: false,
      //   value: "phone_number",
      // },
      {
        text: "ID No",
        align: "left",
        sortable: false,
        value: "id_number",
      },
      {
        text: "Status",
        align: "center",
        sortable: false,
        value: "profile_status",
      },
      {
        text: "Action",
        align: "left",
        sortable: false,
        value: "action",
      },
    ],
  }),
  computed: {
    students() {
      if (this.search === "") {
        return this.$store.getters["Administrator/administratorGetters"](
          "students",
        );
      } else {
        return this.$store.getters["Administrator/administratorGetters"](
          "searchResults",
        );
      }
    },
    studentPages() {
      return this.$store.getters["Administrator/administratorGetters"](
        "studentPages",
      );
    },
    totalRecords() {
      return this.studentPages.total;
    },
    pageCount() {
      return this.studentPages["last_page"];
    },
  },
  methods: {
    sendMessage: function (val) {
      this.selectedUser = val;
      this.messageDialog = true;
    },
    setMessageDialog: function (val) {
      this.messageDialog = val;
    },
    setAccountActivationModal: function (value) {
      this.accountActivationModal = value;
    },
    AddNewAccount() {
      this.accountActivationModal = true;
    },
    deleteUser(data) {
      this.$confirm.show({
        title: "Delete student",
        text: `Are you sure you want to delete student with name '${data.name}'. It cannot be undone`,
        onConfirm: () => {
          this.$store.dispatch("Administrator/deleteStudent", { ...data });
        },
      });
    },
    handlePageChange(value) {
      this.page = value;
      this.$store.dispatch("Administrator/students", {
        params: { page: this.page },
      });
    },
    encode(value) {
      return btoa(JSON.stringify(value));
    },
  },
  watch: {
    deep: true, // detecting nested changes in objects
    immediate: false,
    search() {
      if (this.search.length >= 4) {
        this.$store.dispatch("Administrator/searchStudents", {
          q: this.search,
        });
      }
    },
  },
};
</script>

<style scoped>
@import url("../../styles/administrator.css");
</style>
